export default __webpack_public_path__ + "static/media/Sitewide_cta_banner.912e1efc.jpg";